import { stripeClient } from './providers/stripeClient'
import { multisafepayClient } from './providers/multisafepayClient'
import { UnknownProviderError } from './IPaymentClient'

export function resolveProvider(vendor) {
  if (!vendor) return 'stripe'
  return vendor.defaultProvider || 'stripe'
}

export function paymentClientFactory(vendor) {
  const provider = resolveProvider(vendor)
  switch (provider) {
    case 'stripe': return stripeClient
    case 'multisafepay': return multisafepayClient
    default: throw new UnknownProviderError(provider)
  }
}
